export const translateMask = (mask) => {
  let openTo = 'day'
  const views = []
  const options = {}

  if (!mask) {
    // Sin máscara → fecha completa
    views.push('day', 'month', 'year')
    Object.assign(options, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  } else {
    const upperMask = mask.toUpperCase()

    if (upperMask.includes('DD')) {
      views.push('day')
      options.day = '2-digit'
    }
    if (upperMask.includes('MM')) {
      views.push('month')
      options.month = '2-digit'
    }
    if (upperMask.includes('YYYY')) {
      views.push('year')
      options.year = 'numeric'
    }
    if (upperMask.includes('HH24')) {
      views.push('hours')
      options.hour = '2-digit'
      options.hour12 = false
    }
    if (upperMask.includes('MI')) {
      views.push('minutes')
      options.minute = '2-digit'
    }
    if (upperMask.includes('SS')) {
      views.push('seconds')
      options.second = '2-digit'
    }

    // Determinar "openTo"
    if (views.length === 1 && views[0] === 'year') openTo = 'year'
    else if (!views.some((v) => ['day', 'month', 'year'].includes(v))) openTo = 'hour'
  }

  return { openTo, views, options }
}
